export default __webpack_public_path__ + "static/media/header-bg-47ccfec5e7801597dbbc9dd9bd5130f8.png";